<template>
    <div class="debug-page" style="display: flex">
        <div class="debug-box">
            <h3>Input</h3>

            <el-form style="width: 200px;">
                <el-form-item label="Route Length in Miles">
                    <el-input v-model="route_length_miles"></el-input>
                </el-form-item>
                <el-form-item label="Truck Stop Count">
                    <el-input v-model="gas_station_count"></el-input>
                </el-form-item>
                <el-form-item label="Price From">
                    <el-input v-model="price_from"></el-input>
                </el-form-item>
                <el-form-item label="Route To">
                    <el-input v-model="price_to"></el-input>
                </el-form-item>
                <el-button type="primary" @click="getRandomRoute">Get New Random Route</el-button>
            </el-form>
        </div>

        <div class="debug-box">
            <h3>All Stops</h3>
            <el-timeline>
                <el-timeline-item
                    v-for="(activity, index) in truck_stops"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                    :timestamp="activity.timestamp">
                    {{ activity.content }}
                </el-timeline-item>
            </el-timeline>
        </div>

        <div class="debug-box">
            <h3>Segments</h3>
            <el-timeline>
                <el-timeline-item
                    v-for="(activity, index) in segment_truck_stops"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                    :timestamp="activity.timestamp">
                    {{ activity.content }}
                </el-timeline-item>
            </el-timeline>
        </div>

        <div class="debug-box">
            <h3>Selected</h3>
            <el-timeline>
                <el-timeline-item
                    v-for="(activity, index) in selected_truck_stops"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                    :timestamp="activity.timestamp">
                    {{ activity.content }}
                </el-timeline-item>
            </el-timeline>
        </div>

        <div class="debug-box">
            <h3>Savings</h3>
            <div>Price at avg price: {{ money(savings.price_at_avg_price) }}</div>
            <div>Price at cheap price: {{ money(savings.price_at_cheap_price) }}</div>
            <div>Savings: {{ money(savings.savings) }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ONE_MILE_IN_METERS: 1609.344,

            route_length_miles: 1000,
            gas_station_count: 120,
            price_from: 2.6,
            price_to: 3.4,

            truck_stops: [],
            segment_truck_stops: [],
            selected_truck_stops: [],

            savings: {}
        };
    },
    methods: {
        getRandomRoute() {
            axios.post(url(`hammer/cheap-fuel/random-route`), {
                route_length: this.route_length_miles * this.ONE_MILE_IN_METERS,
                gas_station_count: this.gas_station_count,
                price_from: this.price_from,
                price_to: this.price_to
            }).then((response) => {
                this.truck_stops = _.map(response.data, (t) => {
                    return {
                        content: `${t.name} at ` + this.money(t.price),
                        timestamp: numeral(t.distance_from_origin / this.ONE_MILE_IN_METERS).format('0.0') + 'mi',
                    };
                });

                return axios.post(url(`hammer/cheap-fuel/calculate`), {
                    route_length: this.route_length_miles * this.ONE_MILE_IN_METERS,
                    stops: response.data
                }).then((response) => {
                    this.segment_truck_stops = _.map(response.data.cheapest_in_segments, (t) => {
                        return {
                            content: `${t.name} at ` + this.money(t.price),
                            timestamp: numeral(t.distance_from_origin / this.ONE_MILE_IN_METERS).format('0.0') + 'mi',
                        };
                    });
                    this.selected_truck_stops = _.map(response.data.selected, (t) => {
                        return {
                            content: `${t.name} at ` + this.money(t.price),
                            timestamp: numeral(t.distance_from_origin / this.ONE_MILE_IN_METERS).format('0.0') + 'mi',
                        };
                    });

                    this.savings = response.data.savings;
                });
            });
        }
    }
};
</script>
<style>
.debug-box {
    padding: 10px;
}
</style>